import useAccess from "./useAccess";

const withPermission = (Component) =>
  function WithPermission(props) {
    const { hasPermission, resourcePolicies } = useAccess();

    return (
      <Component
        {...props}
        hasPermission={hasPermission}
        resourcePolicies={resourcePolicies}
      />
    );
  };

export default withPermission;
